import React from 'react';
import Select, { components } from 'react-select';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import classNames from 'classnames';

import IconArrowDownSimple from 'components/icons/iconArrowDownSimple';
import { colorGrayLight5 } from 'styles/layout/colors';

const baseCustomStyles = {
  container: provided => ({
    ...provided,
    width: '100%',
    padding: '.5rem',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderRadius: '4px',
    borderColor: colorGrayLight5,
    cursor: 'pointer',
    position: 'relative',
  }),
  control: () => ({
    border: 0,
    display: 'flex',
    color: '#333',
    width: '100%',
    justifyContent: 'space-between',
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  singleValue: provided => ({
    ...provided,
    color: '#333',
  }),
  valueContainer: () => ({
    display: 'flex',
    padding: '0.125rem 0.5rem',
  }),
};

const DropdownIndicator = props => {
  const {
    selectProps: { menuIsOpen },
  } = props;
  return (
    <components.DropdownIndicator {...props}>
      <IconArrowDownSimple
        data-testid="select-dropdown-button"
        className={classNames({
          'rotate-180': menuIsOpen,
        })}
      />
    </components.DropdownIndicator>
  );
};

DropdownIndicator.propTypes = {
  selectProps: PropTypes.shape({
    menuIsOpen: PropTypes.bool.isRequired,
  }).isRequired,
};

const BaseSelectField = ({
  placeholder,
  onChange,
  options,
  isDisabled = false,
  searchable = false,
  classNamePrefix = '',
  customStyles = {},
  defaultValue = {},
  getOptionLabel = null,
  customComponents = {},
  getOptionValue = null,
  className = '',
  ariaLabel = '',
  value = {},
}) => {
  const conditionalProps = {};
  if (getOptionLabel) {
    conditionalProps.getOptionLabel = getOptionLabel;
  }

  if (getOptionValue) {
    conditionalProps.getOptionValue = getOptionValue;
  }

  if (!isEmpty(value)) {
    conditionalProps.value = value;
  }

  return (
    <Select
      className={`react-select-container w-full ${className}`}
      classNamePrefix={classNamePrefix || 'react-select'}
      placeholder={placeholder}
      onChange={onChange}
      options={options}
      isDisabled={isDisabled}
      isSearchable={searchable}
      defaultValue={defaultValue}
      aria-label={ariaLabel}
      controlShouldRenderValue
      styles={{
        ...baseCustomStyles,
        ...customStyles,
      }}
      components={{
        DropdownIndicator,
        ...customComponents,
      }}
      {...conditionalProps}
    />
  );
};

BaseSelectField.propTypes = {
  ariaLabel: PropTypes.string,
  className: PropTypes.string,
  classNamePrefix: PropTypes.string,
  customComponents: PropTypes.object,
  customStyles: PropTypes.object,
  defaultValue: PropTypes.object,
  getOptionLabel: PropTypes.func,
  getOptionValue: PropTypes.func,
  isDisabled: PropTypes.bool,
  onChange: PropTypes.func,
  options: PropTypes.array,
  placeholder: PropTypes.string,
  searchable: PropTypes.bool,
  value: PropTypes.object,
};

export default BaseSelectField;
